import React from 'react';
import { Box, useMediaQuery, useTheme } from '@mui/material';

const ContactMap = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const isTablet = useMediaQuery(theme.breakpoints.between('sm', 'md'));

  const mapHeight = isMobile ? 350 : isTablet ? 450 : 500;

  return (
    <Box sx={{
      mb: 0,
      borderRadius: { xs: '16px', md: '20px' },
      overflow: 'hidden',
      boxShadow: '0 8px 40px rgba(0, 0, 0, 0.5)',
      border: '1px solid rgba(237, 80, 52, 0.2)',
      transition: 'all 0.3s ease',
      '&:hover': {
        boxShadow: '0 12px 50px rgba(237, 80, 52, 0.4)',
        borderColor: 'rgba(237, 80, 52, 0.4)'
      }
    }}>
      <iframe
        title="Shisha Vibes Location"
        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1108.1202511541449!2d24.764119302135718!3d42.14331008533515!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x14acd13d8b95012d%3A0x164a036d7ad22d62!2sSHISHA%20VIBES!5e0!3m2!1sbg!2sbg!4v1763587129186!5m2!1sbg!2sbg"
        width="100%"
        height={mapHeight}
        style={{ border: 0, display: 'block' }}
        allowFullScreen=""
        loading="lazy"
        referrerPolicy="no-referrer-when-downgrade"
      ></iframe>
    </Box>
  );
};

export default ContactMap;
